import { render, staticRenderFns } from "./loanSummary.vue?vue&type=template&id=0274afbf&scoped=true&"
import script from "./loanSummary.vue?vue&type=script&lang=js&"
export * from "./loanSummary.vue?vue&type=script&lang=js&"
import style0 from "./loanSummary.vue?vue&type=style&index=0&id=0274afbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0274afbf",
  null
  
)

export default component.exports